import themable from '_uikit/_themable'

export const Default = themable('BlogDefaultTile')

export default { Default }
